/** Shared surface styles for Support page hierarchy. */

export const supportSectionShell =
  "rounded-lg border border-gray-300 bg-white shadow-sm ring-1 ring-black/[0.05] overflow-hidden";

export const supportSectionHeader =
  "w-full flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-gray-300 text-left hover:bg-slate-200/60 transition-colors";

export const supportSectionBody = "bg-slate-50/50";

export const supportSubpanel =
  "rounded-md border border-gray-300 bg-white shadow-sm overflow-hidden";

export const supportSubpanelHeader =
  "px-3 py-2 border-b border-gray-200 bg-slate-50";

export const supportInsetPanel =
  "rounded-md border border-gray-300 bg-white shadow-sm h-full";

/** Inset panel without stretching to parent height (e.g. stacked transcript cards). */
export const supportInsetPanelAuto =
  "rounded-md border border-gray-300 bg-white shadow-sm";

export const supportInsetPanelLabel =
  "text-[10px] font-semibold uppercase tracking-wide text-gray-600";

export const supportContextCardTitle = "text-sm font-semibold text-slate-800";

export const supportContextCardPatient = "border-l-[3px] border-l-blue-500";

export const supportContextCardDoctor = "border-l-[3px] border-l-violet-500";

/** Shared body typography for Review Note modal columns. */
export const transcriptNoteModalColumnText =
  "text-base leading-relaxed text-gray-800";
